import psl_ui from '../../libs/psl_ui.js';
import psl_actions from '../../libs/psl_actions.js';

import data from '../../data.js';
import state from '../../state.js';
import analytics from '../analytics/component.js';

import './style.scss';
import template from './template.pst';

psl_ui.templates.add('bottom_menu',template);

const {els,rpoints}=psl_ui.templates.render('bottom_menu',{menu:data.eras,submenu:data.submenu});

psl_actions.add({
	'bottom_menu.toggle':(e,i)=>{
		state.era=i;
		analytics.track_era_toggle(i);
	},
	'roads.toggle':(e)=>{
		state.roads=!state.roads;
		analytics.track_layer_toggle('roads',state.roads);
	},
	'cities.toggle':(e)=>{
		state.cities=!state.cities;
		analytics.track_layer_toggle('cities',state.cities);
	},
	'ama_members.toggle':(e)=>{
		state.ama_members=!state.ama_members;
		analytics.track_layer_toggle('ama_members',state.ama_members);
	},
	'covered_km.toggle':(e)=>{
		state.covered_km=!state.covered_km;
		analytics.track_layer_toggle('covered_km',state.covered_km);
	},
});

rpoints.link_timeline.addEventListener('click',()=>{
	analytics.track_menu_click_external('timeline');
});
rpoints.link_website.addEventListener('click',()=>{
	analytics.track_menu_click_external('ama website');
});

const _submenu_names = data.submenu.map(item=>item.uid);

state.events.on('era',_render);
_submenu_names.forEach(name=>state.events.on(name,_render));

function _render(){
	_submenu_names.forEach(name=>{
		rpoints[`submenu_${name}`].classList.toggle('active',state[name]);
	});
	data.eras.forEach(item=>{
		rpoints[`item_${item.i}`].classList.toggle('active',state.era===item.i);
	});
}

_render();

const _container = document.getElementById('container');

els.forEach(el=>_container.appendChild(el));